import { useState } from 'react'
import { useCreateNote, useGetStageNotes } from '../../api/stage'
import Button from '@mui/material/Button'
import SendIcon from '@mui/icons-material/Send'

interface Props {
  className?: string
  stageId: string
}

export default function SendNoteBar({ stageId, className = '' }: Props) {
  const [note, setNote] = useState('')

  const createNote = useCreateNote(stageId)

  useGetStageNotes(stageId, { enabled: createNote.isSuccess })

  async function handleCreateNote() {
    if (note.length === 0) return
    await createNote.mutateAsync(note)
    setNote('')
  }

  return (
    <div className={`flex flex-row rounded-md h-8 bg-white w-full ${className}`}>
      <textarea
        className="flex-grow py-1 px-2 rounded-md outline-primary-500 resize-none"
        value={note}
        onChange={(e) => setNote(e.target.value)}
        placeholder="نوشتن یادداشت"
      />
      <Button
        variant="contained"
        onClick={handleCreateNote}
        disabled={createNote.isLoading}
        sx={{ px: 1, minWidth: 0 }}
      >
        <SendIcon sx={{ color: 'icon.light' }} />
      </Button>
    </div>
  )
}
